import { render, staticRenderFns } from "./HistorialContaTablaComponent.vue?vue&type=template&id=4561eec3&scoped=true&"
import script from "./HistorialContaTablaComponent.vue?vue&type=script&lang=js&"
export * from "./HistorialContaTablaComponent.vue?vue&type=script&lang=js&"
import style0 from "./HistorialContaTablaComponent.vue?vue&type=style&index=0&id=4561eec3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4561eec3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardText,VDataTable,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSheet})
